import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const careerDegreeRequirements = `${REACT_APP_API_PREFIX}/${service}/careerDegreeRequirements`;

export function getCareerDegreeRequirements(filters) {
  const url = `${careerDegreeRequirements}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getCareerDegreeRequirementById(id) {
  const url = `${careerDegreeRequirements}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateCareerDegreeRequirement(id, body) {
  const url = `${careerDegreeRequirements}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteCareerDegreeRequirement(id) {
  const url = `${careerDegreeRequirements}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createCareerDegreeRequirement(body) {
  const url = `${careerDegreeRequirements}`;
  return {
    method: POST,
    url,
    body,
  };
}
